import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import { Button } from "antd";
import _ from "i18n";

import { setCollaboratorRoles } from "Actions";
import {
  deleteCollaboratorRole,
  saveCollaboratorRole,
  fetchSettingCollaborators,
  fetchCollaboratorSettingSuggestions
} from "Thunks";

import { onSuccess, onError } from "Utils";
import { DIALOG_TYPES } from "../../config";
import TTPDialog from "../Common/TTPDialog";
import { SettingIcon, SvgIcon, ICONS, GarbageIcon } from "../Common/Icons";
import ModalCloseButton from "../Common/Modal/ModalCloseButton";

import styles from "./RegimeSettingContent.local.scss";

class RoleSettingContent extends Component {
  // **** RoleSettingContent (functions) ***** //
  constructor(props) {
    super(props);
    this.state = {
      idRole: null,
      role: {
        id: null,
        label: ""
      },
      disabledSave: true,
      deleteRoleIsVisible: false
    };
  }

  handleDisplayDeleteRole = id => {
    this.setState({
      idRole: id,
      deleteRoleIsVisible: true
    });
  };

  handleDeleteRole = () => {
    const { settingSuggestions } = this.props;
    let updatedRoles = settingSuggestions.data.roles;
    let { idRole } = this.state;
    this.setState({ loading: true });

    this.props.dispatch(deleteCollaboratorRole(idRole)).then(
      res => {
        this.setState({ loading: false });
        onSuccess(res, {
          title: _("removeSuccess"),
          body: _("roleDeleted")
        });
        this.props.dispatch(
          setCollaboratorRoles(updatedRoles.filter(({ id }) => id !== idRole))
        );
        this.props.dispatch(fetchSettingCollaborators());
        this.cancelDeleteRole();
      },
      err => {
        this.cancelDeleteRole();
        this.setState({ loading: false });
        onError(err.response.data.errors[0].message);
      }
    );
  };

  cancelDeleteRole = () => {
    this.setState({
      idRole: null,
      deleteRoleIsVisible: false
    });
  };

  handlePrepareUpdateRole = roleToUpdate => {
    this.setState({ role: roleToUpdate });
  };

  handleChangeRoleLabel = event => {
    this.setState({
      role: { ...this.state.role, label: event.target.value },
      disabledSave: false
    });
  };

  cancelUpdateRole = () => {
    this.setState({
      role: {
        id: null,
        label: ""
      },
      disabledSave: true
    });
  };

  handleSaveRole = () => {
    const { role } = this.state;
    const { dispatch } = this.props;

    // TODO Check if all fields are assigned.

    dispatch(saveCollaboratorRole(role)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: role.id ? _("roleUpdated") : _("roleCreated")
        });

        dispatch(fetchCollaboratorSettingSuggestions());
        this.setState({
          disabledSave: true,
          role: {
            id: null,
            label: ""
          }
        });
      },
      err => {
        onError(
          err.response.data.errors
            ? err.response.data.errors[0].message
            : _("error")
        );
      }
    );
  };

  render() {
    const { settingSuggestions } = this.props;
    const { role } = this.state;
    return (
      <div className="tamtam-modal upload-modal upload-modal__body">
        <ModalCloseButton onClose={this.props.onCancel} />
        <div className="upload-modal__content">
          <div className="upload-modal__header small-12">
            <div className="upload-modal__header-icon">
              <SettingIcon fill="#2495E1" size="20" />
            </div>
            <div className="upload-modal__header-title">
              {_("titleModalRegime")}
            </div>
          </div>
          <div className={styles.modal_content}>
            <div
              className={classnames(
                "columns medium-5 small-5",
                styles.form_frame
              )}
            >
              <h3>{_(role.id ? "updateRole" : "createRole")}</h3>
              <div
                className={classnames(
                  "columns medium-12 small-12",
                  styles.input_div
                )}
              >
                <span>{_("title")}</span>
                <input
                  type={"text"}
                  value={role.label}
                  onChange={event => this.handleChangeRoleLabel(event)}
                />
              </div>
              <div>
                <button
                  type={"success"}
                  className={styles.save_button}
                  disabled={this.state.disabledSave}
                  onClick={this.handleSaveRole}
                >
                  <img
                    src={"/img/icons/tail-spin.svg"}
                    alt={""}
                    className={settingSuggestions.saving ? styles.loading : ""}
                  />
                  {_("save")}
                </button>
                {role.id && (
                  <Button
                    type={"success"}
                    style={{
                      fontFamily: "Roboto",
                      fontStyle: "normal",
                      fontWeight: 500,
                      fontSize: 14,
                      height: 37,
                      margin: "18px 3px 0px",
                      background: "transparent",
                      float: "left",
                      textTransform: "uppercase",
                      color: "#6D7F92"
                    }}
                    onClick={() => this.cancelUpdateRole()}
                  >
                    {_("cancel")}
                  </Button>
                )}
              </div>
            </div>
            <div
              className={classnames(
                "columns medium-6 small-6",
                styles.list_frame
              )}
            >
              <h3>
                {_("rolesList")} ({settingSuggestions.data.roles.length})
              </h3>
              <div className={`${styles.list_items} ${styles.list_roles}`}>
                {settingSuggestions.fetching ? (
                  <div className={styles.ripple_loading}>
                    <img src={"/img/Ripple-1s-150px.svg"} alt="" />
                  </div>
                ) : (
                  settingSuggestions.data.roles &&
                  settingSuggestions.data.roles.map(role => {
                    return (
                      <div key={role.id} className={styles.item}>
                        <span>{role.label}</span>
                        <div
                          className={styles.actions}
                          onClick={event => {
                            event.stopPropagation();
                          }}
                        >
                          <div>
                            <span
                              className={`${styles.action} ${
                                styles.action_edit
                              }`}
                              onClick={() => this.handlePrepareUpdateRole(role)}
                            >
                              <SvgIcon
                                icon={ICONS.PENCIL}
                                className={styles.edit}
                              />
                            </span>
                            <span
                              className={`${styles.action} ${
                                styles.action_delete
                              }`}
                              onClick={() =>
                                this.handleDisplayDeleteRole(role.id)
                              }
                            >
                              <SvgIcon
                                icon={ICONS.Garbage}
                                className={styles.delete}
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        </div>
        <TTPDialog
          showDialog={this.state.deleteRoleIsVisible}
          loading={this.state.loading}
          TTPDialog={{
            approvedAction: this.handleDeleteRole,
            abortAction: this.cancelDeleteRole,
            message: _("confirmationDeleteRoleMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: "yes",
            abortBtnLabel: "no",
            type: DIALOG_TYPES.ALERT,
            title: "confirmationDeleteRoleTitle"
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settingSuggestions: state.collaborator.settingSuggestions
});

export default connect(mapStateToProps)(RoleSettingContent);



// WEBPACK FOOTER //
// ./src/components/CollaboratorSetting/RoleSettingContent.js